import React from 'react';

// 전월 미수 안내 상자 (2026-10-23 1단계 §4-5 · 계약 §2 법무 고정 문구 — 글자 바꾸지 말 것)
// - 인쇄·공유 링크·미리보기에 같은 문구. 치과에 가는 종이라 no-print 아님
// - 합계(totalAmount)에 더하지 않는다. '이번 명세서 포함 받을 금액' 합산 줄은 넣지 않는다(대표 결정)
// - 발행 때 고정한 statement.carryOver 값만 보여 준다(다시 계산하지 않음)

// 보여 줄 조건: include === true 이고 금액이 0보다 큼
export const carryOverToShow = (carryOver) => {
    if (!carryOver || carryOver.include !== true) return null;
    const amount = Number(carryOver.amount) || 0;
    if (amount <= 0) return null;
    return { amount, asOf: String(carryOver.asOf || '') };
};

// 법무 고정 문구 (계약 §2)
export const CARRY_OVER_NOTE_1 = '※ 기공소가 직접 기록한 입금 내역 기준이며, 최근 입금이 반영되지 않았을 수 있습니다.';
export const CARRY_OVER_NOTE_2 = '이미 입금하셨다면 기공소로 알려 주세요. 이 금액은 위 합계와 세금계산서·계산서 금액에 포함되지 않습니다.';
export const carryOverTitle = (labName, asOf) => `전월까지 미수금 (${labName || '기공소'} 입금 기록 기준, ${asOf} 현재)`;

function CarryOverBox({ carryOver, labName, style }) {
    const c = carryOverToShow(carryOver);
    if (!c) return null;
    return (
        <div style={{
            marginTop: 14, padding: '10px 14px', border: '1px solid #94A3B8', borderRadius: 8,
            background: '#fff', fontSize: 13, color: '#334155', ...(style || {}),
        }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 12, flexWrap: 'wrap' }}>
                <span style={{ fontWeight: 600 }}>{carryOverTitle(labName, c.asOf)}</span>
                <span style={{ fontWeight: 700, fontSize: 15, fontVariantNumeric: 'tabular-nums' }}>{c.amount.toLocaleString()}원</span>
            </div>
            <div style={{ marginTop: 6, fontSize: 11.5, color: '#64748B', lineHeight: 1.6 }}>
                {CARRY_OVER_NOTE_1}<br />
                <span style={{ paddingLeft: '1em' }}>{CARRY_OVER_NOTE_2}</span>
            </div>
        </div>
    );
}

export default CarryOverBox;
